import React, {Component, useEffect, useState, useRef, useCallback, useMemo} from "react";
import ButtonRounded from "../../../components/ButtonRounded";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ToggleButton from "../../../components/ToggleButton";
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import {FormattedMessage} from "react-intl";
import { State } from "../../../reducers/reducer";
import { useSelector } from "react-redux";
import getAllocationPageData from "../../../api/sustainability/allocation/collaboration/get";
import {useHistory, useRouteMatch} from "react-router-dom";
import { hasRoadData, deleteRoadUseData } from "../../../api/sustainability/allocation/roadUse/data";
import {
    hasOffRoadData,
    deleteOffRoadUseData, updateOffroadMandateFlexibility,
    toggleOffroadMandateStatus, toggleOffroadJointFulfillmentStatus, getMandateStatuses
} from "../../../api/sustainability/allocation/offRoadUse/data";
import {
    hasMarineData,
    toggleMarineMandateStatus, toggleMarineJointFulfillmentStatus
} from "../../../api/sustainability/allocation/marineUse/data";
// @ts-ignore
import { toggleSimulation } from "../../../reducers/sustainability/main";
import { useDispatch } from "react-redux";
import resetAllocation from "../../../api/sustainability/allocation/roadUse/stepData";
import {resetAllocationOffroad} from "../../../api/sustainability/allocation/offRoadUse/stepData";
import { getConfirmState, checkConfirmState } from "../../../api/sustainability/reports/getConfirmState";
import { checkDisableConfirm } from "../../../api/sustainability/reports/getConfirmState";
import {emptyKey} from "../../../reducers/sustainability/allocation/roaduseAllocation";
import {emptyKey as emptyKeyOffroad} from "../../../reducers/sustainability/allocation/offRoadAllocation";
import {emptyKey as emptyKeyMarine} from "../../../reducers/sustainability/allocation/marineAllocation";
import {toggleRoaduseMandateStatus, toggleRoaduseJointFulfillmentStatus, updateRoaduseMandateFlexibility} from "../../../api/sustainability/allocation/roadUse/data";
import { resetAllocationMarine } from "../../../api/sustainability/allocation/marineUse/stepData";
import parseAndFormat from "../../../components/texts/parseAndFormat";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CreatableSelect from "react-select/creatable";
import {creatableSelectStyles} from "../../../common/styles/creatableSelectStyles";
import { arrowProgressBarStyles } from "../../../common/styles/arrowProgressBarStyles";
import { overviewCardStyles } from "../../../common/styles/cardStyles";

// Lazy load heavy modal components
const ModalInfo = React.lazy(() => import("../../../components/modal/ModalInfo"));
const ModalConfirmDelivery = React.lazy(() => import("../../../views/DashboardView/SustainabilityView/ReportsView/ModalConfirmDelivery"));
const ModalDeleteVolumeInMandate = React.lazy(() => import("../../../components/FilesTable/ModalDeleteVolumeInMandate"));
const ModalRestartAllocation = React.lazy(() => import("../../../components/FilesTable/ModalRestartAllocation"));
const ModalToggleMandate = React.lazy(() => import("../../../components/FilesTable/ModalToggleMandate"));

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        h2: {
            [theme.breakpoints.down("md")]: {
                fontSize: "32px",
            },
        },
        btn: {
            minWidth: "200px",
            "&:not(:first-child)": {
                marginLeft: "20px",
                [theme.breakpoints.down("md")]: {
                    marginLeft: "10px",
                },
            },
        },
        buttonMargin: {
            marginBottom: theme.spacing(1),
        },
        toggleButtonMargin: {
            marginBottom: theme.spacing(2),
        },
        toggleCardContainer: {
            marginTop: theme.spacing(3),
        },
        toggleCardContent: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        toggleCardTitle: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        tableTitle: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(3),
        },
        outputTableTopLabel: {
            marginBottom: theme.spacing(1),
            marginLeft: theme.spacing(2),
        },
        table: {
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: "none",
                paddingTop: 0,
                paddingBottom: 0,
                height: theme.spacing(4),
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontSize: "11px",
                fontWeight: 700,
            },
        },
        iconBtn: {
            padding: 0,
            marginLeft: theme.spacing(2),
        },
        companyName: {
            fontWeight: 500,
            color: theme.palette.primary.main,
        },
        paginationContainer: {
            display: "flex",
            justifyContent: "flex-end",
            marginTop: theme.spacing(3),
        },
        addButton: {
            minWidth: "200px",
        },
        circularProgress: {
            margin: "80px",
            width: "48px",
            height: "48px",
        },
        soldVolumesTotal: {
            "& .MuiTableCell-root": {
                fontWeight: 700,
                paddingTop: theme.spacing(1.5),
                paddingBottom: theme.spacing(1.5),
                paddingRight: theme.spacing(3.8),
            },
        },
        ...overviewCardStyles(theme),
        ...creatableSelectStyles(theme),
        creatableSelectPrimaryBorder: {
            "& .react-select__control": {
                borderColor: theme.palette.primary.main,
                "&:hover": {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
        ...arrowProgressBarStyles(theme),
    })
);

const MandateOverviewContainer: React.FC = React.memo(() => {
    const classes = useStyles();
    const match = useRouteMatch();
    const history = useHistory();
    const dispatch = useDispatch();

    const [isRestartRoaduseModalOpen, setIsRestartRoaduseModalOpen] = useState(false);
    const [isRestartOffroadModalOpen, setIsRestartOffroadModalOpen] = useState(false);
    const [isRestartMarineModalOpen, setIsRestartMarineModalOpen] = useState(false);
    const [isToggleOffroadMarineModalOpen, setIsToggleOffroadMarineModalOpen] = useState(false);

    const flexibilityOptionsRoaduse = useMemo(() => [
        { value: 0, label: "Do not use surplus from off-road mandate" },
        { value: 1, label: "Use surplus from off-road mandate" }
    ], []);

    const flexibilityOptionsOffroad = useMemo(() => [
        { value: 0, label: "Do not use surplus from road use mandate" },
        { value: 1, label: "Use surplus from road use mandate" }
    ], []);

    const [selectedFlexibilityRoaduse, setSelectedFlexibilityRoaduse] =
        useState<{ value: number; label: string } | null>(
        flexibilityOptionsRoaduse.find(option => option.value === 0) || null
    );
    const [selectedFlexibilityOffroad, setSelectedFlexibilityOffroad] =
        useState<{ value: number; label: string } | null>(
        flexibilityOptionsOffroad.find(option => option.value === 0) || null
    );

    const handleCloseToggleOffroadMarineModal = () => {
        setIsToggleOffroadMarineModalOpen(false);
    };

    const handleCloseRestartRoaduseModal = () => {
        setIsRestartRoaduseModalOpen(false);
    };

    const handleConfirmAndRestartRoaduse = async () => {
        handleCloseRestartRoaduseModal();
        await handleStartAllocation();
    };

    const handleCloseRestartOffroadModal = () => {
        setIsRestartOffroadModalOpen(false);
    };

    const handleConfirmAndRestartOffroad = async () => {
        handleCloseRestartOffroadModal();
        await handleOffRoadReport();
    };

    const handleCloseRestartMarineModal = () => {
        setIsRestartMarineModalOpen(false);
    };

    const handleConfirmAndRestartMarine = async () => {
        handleCloseRestartMarineModal();
        await handleMarineReport();
    };

    const isSimulation = useSelector((state: State) => state.sustainability.main.isSimulation);
    const activePeriod = useSelector((state: State) => state.sustainability.main.activePeriod);

    const [isRoadUseToggleButtonEnabled, setIsRoadUseToggleButtonEnabled] = useState(true);
    const [isOffRoadToggleButtonEnabled, setIsoffRoadToggleButtonEnabled] = useState(true);
    const [isMarineToggleButtonEnabled, setIsMarineToggleButtonEnabled] = useState(true);

    const [isRoadUseJoint, setIsRoadUseJoint] = useState(false);
    const [isOffRoadJoint, setIsOffRoadJoint] = useState(false);
    const [isMarineJoint, setIsMarineJoint] = useState(false);

    const [areButtonsVisibleRoadUse, setAreButtonsVisibleRoadUse] = useState(true);
    const [areButtonsVisibleOffRoad, setAreButtonsVisibleOffRoad] = useState(true);
    const [areButtonsVisibleMarine, setAreButtonsVisibleMarine] = useState(true);
    const [marineDataId, setMarineDataId] = useState<any>(null);
    const [marineHasStep, setMarineHasStep] = useState<boolean>(false);
    const [roadUseId, setRoadUseId] = useState<any>(null);
    const [roadUseHasStep, setRoadUseHasStep] = useState<boolean>(false);
    const [roadUseVolConfirmed, setRoadUseVolConfirmed] = useState<boolean>(false);
    const [offRoadUseId, setOffRoadUseId] = useState<any>(null);
    const [offRoadUseHasStep, setOffRoadUseHasStep] = useState<boolean>(false);
    const [offRoadVolConfirmed, setOffRoadVolConfirmed] = useState<boolean>(false);
    const [marineVolConfirmed, setMarineVolConfirmed] = useState<boolean>(false);
    const [confirmState, setConfirmState] = useState<boolean>(false);
    const [disableConfirm, setDisableConfirm] = useState<boolean>(false);
    const [showModalDeleteRoaduse, setShowModalDeleteRoaduse] = useState<boolean>(false);
    const [showModalDeleteOffRoad, setShowModalDeleteOffRoad] = useState<boolean>(false);
    const [showModalDeleteMarine, setShowModalDeleteMarine] = useState<boolean>(false);
    const [mandateLevels, setMandateLevels] = useState({
        roaduseGeneral: "",
        roaduseGasolineSub: "",
        roaduseAdvancedSub: "",
        offroadGeneral: "",
        marineGeneral: "",
    });
    const [mandateStatuses, setMandateStatuses] = useState({
        roaduseVolume: ["", ""],
        roaduseAllocation: ["", ""],
        roaduseReport: ["", ""],
        roaduseSteps: ["", "", "", "", ""],
        offroadVolume: ["", ""],
        offroadAllocation: ["", ""],
        offroadReport: ["", ""],
        offroadSteps: ["", "", ""],
        marineVolume: ["", ""],
        marineAllocation: ["", ""],
        marineReport: ["", ""],
        marineSteps: ["", "", ""],
    });

    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
    const [
        showConfirmDeliveryModal,
        setShowConfirmDeliveryModal,
    ] = useState<boolean>(false);

    const openErrorModal = (msg: string) => {
        setErrorMessage(msg);
        setShowErrorModal(true);
    };
    const closeErrorModal = () => {
        setErrorMessage("");
        setShowErrorModal(false);
    };

    const openConfirmDeliveryModal = () => {
        setShowConfirmDeliveryModal(true);
    };

    const closeConfirmDeliveryModal = () => {
        setShowConfirmDeliveryModal(false);
    };

    const openModalDeleteRoaduse = () => {
        setShowModalDeleteRoaduse(true);
    };
    const closeModalDeleteRoaduse = () => {
        setShowModalDeleteRoaduse(false);
    };

    const openModalDeleteOffRoad = () => {
        setShowModalDeleteOffRoad(true);
    };
    const closeModalDeleteOffRoad = () => {
        setShowModalDeleteOffRoad(false);
    };
    const openModalDeleteMarine = () => {
        setShowModalDeleteMarine(true);
    };
    const closeModalDeleteMarine = () => {
        setShowModalDeleteMarine(false);
    };
    const handleRoadUseVolume = () => {
        if (match) {
            history.push(`/sustainability/mandateoverview/roadusevolumes`);
        }
    };
    const goToReportOverview = () => {
        if (match) {
            history.push(`/sustainability/reportoverview/`);
        }
    };

    const handleStartAllocation = async () => {
        const response = await resetAllocation();
        dispatch(emptyKey());
        if (response && response.success) {
            if (match) {
                history.push(`/sustainability/mandateoverview/roaduse/allocation`);
            }
        } else {
            alert("Error occured when reseting allocation");
        }

    };

    // Change the function name later
    const handleContinueAllocation = async () => {
        if (match) {
            history.push(`/sustainability/mandateoverview/roaduse/allocation`);
        }
    };

    const handleRoaduseFlexibility = useCallback((selected: any) => {
        if ((selected.value === 1 && isOffRoadToggleButtonEnabled) || selected.value === 0) {
            setSelectedFlexibilityRoaduse(selected);
            updateRoaduseMandateFlexibility(selected.value).then(() => {
                if (selected.value === 1) {
                    const offroadOption = flexibilityOptionsOffroad.find(opt => opt.value === 0) || null;
                    setSelectedFlexibilityOffroad(offroadOption);
                    updateOffroadMandateFlexibility(false);
                }
            }).catch(error => {
                console.error("Error updating mandate status:", error);
            });
        }
    }, [isOffRoadToggleButtonEnabled, flexibilityOptionsOffroad]);

    const handleOffroadFlexibility = useCallback((selected: any) => {
        if ((selected.value === 1 && isRoadUseToggleButtonEnabled) || selected.value === 0) {
            setSelectedFlexibilityOffroad(selected);
            updateOffroadMandateFlexibility(selected.value).then(() => {
                if (selected.value === 1) {
                    const roaduseOption = flexibilityOptionsRoaduse.find(opt => opt.value === 0) || null;
                    setSelectedFlexibilityRoaduse(roaduseOption);
                    updateRoaduseMandateFlexibility(false);
                }
            }).catch(error => {
                console.error("Error updating mandate status:", error);
            });
        }
    }, [isRoadUseToggleButtonEnabled, flexibilityOptionsRoaduse]);

    const toggleRoaduseMandateState =  (label: string) => {
        const isEnable = label !== "Disabled";
        setIsRoadUseToggleButtonEnabled(isEnable);
        toggleRoaduseMandateStatus(isEnable).then(() => {
            checkDisableConfirmation();
        }).catch(error => {
            // tslint:disable-next-line:no-console
            console.error("Error updating mandate status:", error);
        });
        // @ts-ignore
        if (!isEnable && selectedFlexibilityOffroad.value === 1) {
            const offroadOption = flexibilityOptionsOffroad.find(opt => opt.value === 0) || null;
            setSelectedFlexibilityOffroad(offroadOption);
            updateOffroadMandateFlexibility(false);
        }
    };

    const toggleOffroadMandateState =  (label: string) => {
        const isEnable = label !== "Disabled";
        setIsoffRoadToggleButtonEnabled(isEnable);
        toggleOffroadMandateStatus(isEnable).then(() => {
            checkDisableConfirmation();
        }).catch(error => {
            // tslint:disable-next-line:no-console
            console.error("Error updating mandate status:", error);
        });
        if (isEnable && isMarineToggleButtonEnabled) {
            setIsToggleOffroadMarineModalOpen(true);
        }
        // @ts-ignore
        if (!isEnable && selectedFlexibilityRoaduse.value === 1) {
            const roaduseOption = flexibilityOptionsRoaduse.find(opt => opt.value === 0) || null;
            setSelectedFlexibilityRoaduse(roaduseOption);
            updateRoaduseMandateFlexibility(false);
        }
    };

    const toggleMarineMandateState =  (label: string) => {
        const isEnable = label !== "Disabled";
        setIsMarineToggleButtonEnabled(isEnable);
        toggleMarineMandateStatus(isEnable).then(() => {
            checkDisableConfirmation();
        }).catch(error => {
            console.error("Error updating mandate status:", error);
        });
        if (isEnable && isOffRoadToggleButtonEnabled) {
            setIsToggleOffroadMarineModalOpen(true);
        }
    };

    const toggleRoaduseJointfulfullmentState =  (label: string) => {
        const isEnable = label !== "Own Fullfillment";
        setIsRoadUseJoint(isEnable);
        toggleRoaduseJointFulfillmentStatus(isEnable);
    };

    const toggleOffroadJointFulfillmentState =  (label: string) => {
        const isEnable = label !== "Own Fullfillment";
        setIsOffRoadJoint(isEnable);
        toggleOffroadJointFulfillmentStatus(isEnable);
    };

    const toggleMarineJointFulfillmentState =  (label: string) => {
        const isEnable = label !== "Own Fullfillment";
        setIsMarineJoint(isEnable);
        toggleMarineJointFulfillmentStatus(isEnable);
    };

    const handleOffRoadReport = async () => {
        const response = await resetAllocationOffroad();
        dispatch(emptyKeyOffroad());
        if (response && response.success) {
            if (match) {
                history.push(`/sustainability/mandateoverview/offroad/allocation`);
            }
        }
    };
    const handleContinueAllocationOffroad = async () => {
            if (match) {
                history.push(`/sustainability/mandateoverview/offroad/allocation`);
            }
    };

    const handleMarineReport = async () => {
        const response = await resetAllocationMarine();
        dispatch(emptyKeyMarine());
        if (response && response.success) {
            if (match) {
                history.push(`/sustainability/mandateoverview/marine/allocation`);
            }
        }
    };
    const handleContinueAllocationMarine = async () => {
        if (match) {
            history.push(`/sustainability/mandateoverview/marine/allocation`);
        }
    };
    const handleOffRoadVolume = () => {
        if (match) {
            history.push(`/sustainability/mandateoverview/offroadvolumes`);
        }
    };
    const handleMarineVolume = () => {
        if (match) {
            history.push(`/sustainability/mandateoverview/marinevolumes`);
        }
    };

    const checkData = useCallback(async () => {
        try {
            // Parallel API calls for better performance
            const [roadUse, offRoadUse, marine] = await Promise.all([
                hasRoadData(),
                hasOffRoadData(),
                hasMarineData()
            ]);

            if (roadUse) {
                setRoadUseId(roadUse.id);
                setRoadUseVolConfirmed(roadUse.volume_confirmed);
                setRoadUseHasStep(!!roadUse.last_active_step);
                setIsRoadUseToggleButtonEnabled(roadUse.mandate_enabled);
                setIsRoadUseJoint(roadUse.joint_fulfillment);
                setMandateLevels(prev => ({
                    ...prev,
                    roaduseGeneral: parseAndFormat(roadUse.general_mandate, 2),
                    roaduseGasolineSub: parseAndFormat(roadUse.gasoline_sub_mandate, 2),
                    roaduseAdvancedSub: parseAndFormat(roadUse.advanced_sub_mandate, 2)
                }));
                setSelectedFlexibilityRoaduse(
                    flexibilityOptionsRoaduse.find(option => option.value === (roadUse.use_offroad_surplus ? 1 : 0)) || null
                );
            }

            if (offRoadUse) {
                setOffRoadUseId(offRoadUse.id);
                setOffRoadVolConfirmed(offRoadUse.volume_confirmed);
                setOffRoadUseHasStep(!!offRoadUse.last_active_step);
                setIsoffRoadToggleButtonEnabled(offRoadUse.mandate_enabled);
                setIsOffRoadJoint(offRoadUse.joint_fulfillment);
                setMandateLevels(prev => ({
                    ...prev,
                    offroadGeneral: parseAndFormat(offRoadUse.general_mandate, 2),
                }));
                setSelectedFlexibilityOffroad(
                    flexibilityOptionsOffroad.find(option => option.value === (offRoadUse.use_roaduse_surplus ? 1 : 0)) || null
                );
            }

            if (marine) {
                setMarineDataId(marine.id);
                setMarineVolConfirmed(marine.volume_confirmed);
                setMarineHasStep(!!marine.last_active_step);
                setIsMarineToggleButtonEnabled(marine.mandate_enabled);
                setIsMarineJoint(marine.joint_fulfillment);
                setMandateLevels(prev => ({
                    ...prev,
                    marineGeneral: parseAndFormat(marine.general_mandate, 2),
                }));
            }

            // Run confirmation checks in parallel
            await Promise.all([
                checkConfirmationStatus(),
                checkDisableConfirmation()
            ]);
        } catch (error) {
            console.error('Error loading mandate data:', error);
        }
    }, []);

    const isMounted = useRef(true);

    const handleConfirmationStatus = async () => {
        if (activePeriod && activePeriod.year) {
            // @ts-ignore
            const res = await getConfirmState({ taxYear: activePeriod.year });
            if (res === null) {
                openErrorModal(
                    "Failed to confirm delivery. Possible errors: correct reporting year is not selected or other errors."
                );
            } else {
                openErrorModal(
                    "Delivery Confirmed."
                );
            }
            checkData();
        }
    };

    const checkConfirmationStatus = useCallback(async () => {
        if (activePeriod && activePeriod.year) {
            // @ts-ignore
            // tslint:disable-next-line:no-shadowed-variable
            let confirmState: any;
            confirmState = await checkConfirmState({taxYear: activePeriod.year});
            setConfirmState(confirmState);
        }
    }, [activePeriod]);

    const checkDisableConfirmation = useCallback(async () => {
        try {
            const promises = [];
            if (activePeriod && activePeriod.year) {
                promises.push(checkDisableConfirm({taxYear: activePeriod.year}));
            }
            promises.push(getMandateStatuses());
            const [disableConfirm, statusData] = await Promise.all(promises);

            if (disableConfirm !== undefined) {
                setDisableConfirm(disableConfirm);
            }

            if (statusData) {
                setMandateStatuses({
                    roaduseVolume: statusData.roaduseVolume,
                    roaduseAllocation: statusData.roaduseAllocation,
                    roaduseReport: statusData.roaduseReport,
                    roaduseSteps: statusData.roaduseSteps,
                    offroadVolume: statusData.offroadVolume,
                    offroadAllocation: statusData.offroadAllocation,
                    offroadReport: statusData.offroadReport,
                    offroadSteps: statusData.offroadSteps,
                    marineVolume: statusData.marineVolume,
                    marineAllocation: statusData.marineAllocation,
                    marineReport: statusData.marineReport,
                    marineSteps: statusData.marineSteps,
                });
            }
        } catch (error) {
            console.error('Error checking confirmation status:', error);
        }
    }, [activePeriod]);

    useEffect(() => {
        setAreButtonsVisibleRoadUse(isRoadUseToggleButtonEnabled);
        setAreButtonsVisibleOffRoad(isOffRoadToggleButtonEnabled);
        setAreButtonsVisibleMarine(isMarineToggleButtonEnabled);
    }, [isSimulation, isRoadUseToggleButtonEnabled, isOffRoadToggleButtonEnabled, isMarineToggleButtonEnabled]);

    // Memoize params to prevent unnecessary re-renders
    const allocationParams = useMemo(() => ({
        allocation: isSimulation ? "Simulation" : "Reporting",
        fulfilment: "own",
        taxYearId: activePeriod ? activePeriod.id : undefined,
    }), [isSimulation, activePeriod]);

    // Single useEffect for initial data loading and updates
    useEffect(() => {
        if (!activePeriod || !activePeriod.id) { return; }

        const loadData = async () => {
            try {
                await Promise.all([
                    getAllocationPageData(allocationParams),
                    checkData()
                ]);
            } catch (error) {
                console.error('Error loading data:', error);
            }
        };

        loadData();
    }, [allocationParams, checkData]);

    // Cleanup effect
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    const currentYear = useMemo(() => new Date().getFullYear(), []);

    const reloadPageData = useCallback(async () => {
        try {
            await Promise.all([
                getAllocationPageData(allocationParams),
                checkData()
            ]);
        } catch (error) {
            console.error('Error reloading page data:', error);
        }
    }, [allocationParams, checkData]);

    // @ts-ignore
    return (
        <div>
            <h1>Bio mandate reporting</h1>
            <div className={classes.cardContainer}>
                <Card className={`${classes.card} ${classes.cardReport}`}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="h5" className={classes.toggleCardTitle}>
                            <FormattedMessage id="allocationView.mainView.allocationMode"/>
                        </Typography>

                        <ToggleButton
                            labels={["Reporting", "Simulation"]}
                            defaultLabelIndex={isSimulation ? 1 : 0}
                            handleChange={() => {
                                dispatch(toggleSimulation());
                                setTimeout(() => reloadPageData(), 0);
                            }}
                        />
                    </CardContent>
                </Card>
                <Card className={`${classes.card} ${classes.cardAllocation}`}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="h5" className={classes.cardTitle}>
                            <p>Report File and Actions</p>
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                <ButtonRounded
                                    variant="outlined"
                                    color="default"
                                    fullWidth
                                    onClick={openConfirmDeliveryModal}
                                    disabled={disableConfirm || confirmState}
                                >
                                    {confirmState ? (
                                        <FormattedMessage id="sustainabilityView.reportsView.confirmed" />
                                    ) : (
                                        <FormattedMessage id="loginView.confirm" />
                                    )}{" "}
                                    <FormattedMessage id="sustainabilityView.reportsView.delivery" />
                                </ButtonRounded>

                            </Grid>
                            <Grid item xs={6}>
                                <ButtonRounded
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={goToReportOverview}
                                    className={classes.buttonMargin}
                                    disabled={false}
                                >
                                    Report overview
                                </ButtonRounded>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>

                <Card className={`${classes.card}`}>
                    <CardContent className={classes.cardContent}>
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                <h1>Road use mandate for {activePeriod ? activePeriod.year : currentYear - 1}</h1>
                                <p>The road use mandate in {activePeriod ? activePeriod.year : currentYear - 1} is {mandateLevels.roaduseGeneral} %.
                                    In addition to the general mandate level, the road use mandate also contains
                                    separate sub-mandates for gasoline ({mandateLevels.roaduseGasolineSub} %) and minimum
                                    volume of biofuels with advanced sustainability criteria
                                    ({mandateLevels.roaduseAdvancedSub} %).</p>

                                {areButtonsVisibleRoadUse && (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <div className={classes.containerArrowProgressbar}>
                                                <div className={classes.wrapper}>
                                                    <div className={`${classes.arrowSteps} ${classes.clearfixAfter}`}>
                                                        <div className={`step ${mandateStatuses.roaduseVolume[0]}`}>
                                                            <span>{mandateStatuses.roaduseVolume[1]}</span>
                                                        </div>
                                                        <div className={`step ${mandateStatuses.roaduseAllocation[0]}`}>
                                                            <span>{mandateStatuses.roaduseAllocation[1]}</span>
                                                        </div>
                                                        <div className={`step ${mandateStatuses.roaduseReport[0]}`}>
                                                            <span>{mandateStatuses.roaduseReport[1]}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <ButtonRounded
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={handleRoadUseVolume}
                                                className={classes.buttonMargin}
                                                disabled={roadUseId !== null && roadUseVolConfirmed}
                                            >
                                                Add Volume
                                            </ButtonRounded>
                                            <ButtonRounded
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={handleRoadUseVolume}
                                                className={classes.buttonMargin}
                                                disabled={roadUseId === null || (roadUseId && !roadUseVolConfirmed)}
                                            >
                                                Edit Volume
                                            </ButtonRounded>
                                            <ButtonRounded
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                disabled={roadUseId === null || (roadUseId && !roadUseVolConfirmed)}
                                                onClick = {() => openModalDeleteRoaduse()}
                                            >
                                                Delete Volumes
                                            </ButtonRounded>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <ButtonRounded
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={handleStartAllocation}
                                                className={classes.buttonMargin}
                                                disabled={roadUseId === null || roadUseHasStep || !roadUseVolConfirmed}
                                            >
                                                    Start Allocation
                                            </ButtonRounded>
                                            <ButtonRounded
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={() => setIsRestartRoaduseModalOpen(true)}
                                                className={classes.buttonMargin}
                                                disabled={roadUseId === null || !roadUseHasStep}
                                            >
                                                Restart Allocation
                                            </ButtonRounded>
                                            <ButtonRounded
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={handleContinueAllocation}
                                                disabled={roadUseId === null || !roadUseHasStep}
                                            >
                                                Continue Allocation
                                            </ButtonRounded>
                                        </Grid>
                                    </Grid>
                                )}
                                {showModalDeleteRoaduse && (
                                    <React.Suspense fallback={<div>Loading...</div>}>
                                        <ModalDeleteVolumeInMandate
                                            open={showModalDeleteRoaduse}
                                            handleDelete={async () => {
                                                await deleteRoadUseData(roadUseId);
                                                await resetAllocation();
                                                await toggleRoaduseMandateStatus(true);
                                                // await checkData();
                                                window.location.reload();
                                            }}
                                            onClose={closeModalDeleteRoaduse}
                                        />
                                    </React.Suspense>
                                )}
                                {isRestartRoaduseModalOpen && (
                                    <React.Suspense fallback={<div>Loading...</div>}>
                                        <ModalRestartAllocation
                                            open={isRestartRoaduseModalOpen}
                                            handleRestart={handleConfirmAndRestartRoaduse}
                                            onClose={handleCloseRestartRoaduseModal}
                                        />
                                    </React.Suspense>
                                )}
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="h5" className={classes.toggleCardTitle}>
                                    <p>Mandate settings</p>
                                </Typography>

                                <div className={classes.toggleButtonMargin}>
                                <ToggleButton
                                    labels={["Enabled", "Disabled"]}
                                    defaultLabelIndex={isRoadUseToggleButtonEnabled ? 0 : 1}
                                    handleChange={toggleRoaduseMandateState}
                                />
                                </div>
                                {isRoadUseToggleButtonEnabled && (
                                    <>
                                        <div className={classes.toggleButtonMargin}>
                                        <ToggleButton
                                            labels={["Joint Fullfillment", "Own Fullfillment"]}
                                            defaultLabelIndex={isRoadUseJoint ? 0 : 1}
                                            handleChange={toggleRoaduseJointfulfullmentState}
                                        />
                                        </div>
                                        <br></br>
                                        <Typography variant="h5" className={classes.toggleCardTitle}>
                                            <p>Mandate flexibility</p>
                                        </Typography>
                                        <div>
                                            <CreatableSelect
                                                isDisabled={false}
                                                className={`${classes.creatableSelect} ${classes.creatableSelectPrimaryBorder}`}
                                                classNamePrefix="react-select"
                                                placeholder="Mandate flexibility Roaduse"
                                                components={{
                                                    DropdownIndicator: () => <ArrowDropDownIcon />,
                                                }}
                                                options={flexibilityOptionsRoaduse}
                                                value={selectedFlexibilityRoaduse}
                                                onChange={handleRoaduseFlexibility}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 99999 })
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Card className={`${classes.card}`}>
                    <CardContent className={classes.cardContent}>
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                <h1>Off-road mandate for {activePeriod ? activePeriod.year : currentYear - 1}</h1>
                                <p>The off-road mandate in {activePeriod ? activePeriod.year : currentYear - 1} is {mandateLevels.offroadGeneral} %. Fulfillment
                                    of this mandate is only possible with biofuels that have advanced sustainability criteria.</p>

                                {areButtonsVisibleOffRoad && (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <div className={classes.containerArrowProgressbar}>
                                                <div className={classes.wrapper}>
                                                    <div className={`${classes.arrowSteps} ${classes.clearfixAfter}`}>
                                                        <div className={`step ${mandateStatuses.offroadVolume[0]}`}>
                                                            <span>{mandateStatuses.offroadVolume[1]}</span>
                                                        </div>
                                                        <div className={`step ${mandateStatuses.offroadAllocation[0]}`}>
                                                            <span>{mandateStatuses.offroadAllocation[1]}</span>
                                                        </div>
                                                        <div className={`step ${mandateStatuses.offroadReport[0]}`}>
                                                            <span>{mandateStatuses.offroadReport[1]}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleOffRoadVolume}
                                            className={classes.buttonMargin}
                                            disabled={offRoadUseId !== null && offRoadVolConfirmed}
                                        >
                                            Add Volume
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleOffRoadVolume}
                                            className={classes.buttonMargin}
                                            disabled={offRoadUseId === null || (offRoadUseId && !offRoadVolConfirmed)}
                                        >
                                            Edit Volume
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={() => openModalDeleteOffRoad()}
                                            className={classes.buttonMargin}
                                            disabled={offRoadUseId === null || (offRoadUseId && !offRoadVolConfirmed)}
                                        >
                                            Delete Volumes
                                        </ButtonRounded>
                                        </Grid>
                                        <Grid item xs={4}>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleOffRoadReport}
                                            className={classes.buttonMargin}
                                            disabled={offRoadUseId === null || offRoadUseHasStep || !offRoadVolConfirmed}
                                        >
                                            Start Allocation
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={() => setIsRestartOffroadModalOpen(true)}
                                            className={classes.buttonMargin}
                                            disabled={offRoadUseId === null || !offRoadUseHasStep}
                                        >
                                            Restart Allocation
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleContinueAllocationOffroad}
                                            className={classes.buttonMargin}
                                            disabled={offRoadUseId === null || !offRoadUseHasStep}
                                        >
                                            Continue Allocation
                                        </ButtonRounded>
                                    </Grid>

                                </Grid>
                                )}
                                {showModalDeleteOffRoad && (
                                    <React.Suspense fallback={<div>Loading...</div>}>
                                        <ModalDeleteVolumeInMandate
                                            open={showModalDeleteOffRoad}
                                            handleDelete={async () => {
                                                await deleteOffRoadUseData(offRoadUseId, "offroad");
                                                await resetAllocationOffroad();
                                                await toggleOffroadMandateStatus(true);
                                                // await checkData();
                                                window.location.reload();
                                            }}
                                            onClose={closeModalDeleteOffRoad}
                                        />
                                    </React.Suspense>
                                )}
                                {isRestartOffroadModalOpen && (
                                    <React.Suspense fallback={<div>Loading...</div>}>
                                        <ModalRestartAllocation
                                            open={isRestartOffroadModalOpen}
                                            handleRestart={handleConfirmAndRestartOffroad}
                                            onClose={handleCloseRestartOffroadModal}
                                        />
                                    </React.Suspense>
                                )}
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="h5" className={classes.toggleCardTitle}>
                                    <p>Mandate settings</p>
                                </Typography>
                                <div className={classes.toggleButtonMargin}>
                                    <ToggleButton
                                        labels={["Enabled", "Disabled"]}
                                        defaultLabelIndex={isOffRoadToggleButtonEnabled ? 0 : 1}
                                        handleChange={toggleOffroadMandateState}
                                    />
                                </div>
                                {isOffRoadToggleButtonEnabled && (
                                    <>
                                        <div className={classes.toggleButtonMargin}>
                                        <ToggleButton
                                            labels={["Joint Fullfillment", "Own Fullfillment"]}
                                            defaultLabelIndex={isOffRoadJoint ? 0 : 1}
                                            handleChange={toggleOffroadJointFulfillmentState}
                                        />
                                        </div>
                                        <br></br>
                                        <Typography variant="h5" className={classes.toggleCardTitle}>
                                            <p>Mandate flexibility</p>
                                        </Typography>
                                        <div>
                                            <CreatableSelect
                                                isDisabled={false}
                                                className={`${classes.creatableSelect} ${classes.creatableSelectPrimaryBorder}`}
                                                classNamePrefix="react-select"
                                                placeholder="Mandate flexibility Offroad"
                                                components={{
                                                    DropdownIndicator: () => <ArrowDropDownIcon />,
                                                }}
                                                options={flexibilityOptionsOffroad}
                                                value={selectedFlexibilityOffroad}
                                                onChange={handleOffroadFlexibility}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 99999 })
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Card className={`${classes.card}`}>
                    <CardContent className={classes.cardContent}>
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                <h1>Marine mandate for {activePeriod ? activePeriod.year : currentYear - 1}</h1>
                                <p>The marine mandate in {activePeriod ? activePeriod.year : currentYear - 1} is {mandateLevels.marineGeneral} %. Fulfillment
                                    of this mandate is only possible with biofuels that have advanced sustainability criteria.</p>

                                {areButtonsVisibleMarine && (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <div className={classes.containerArrowProgressbar}>
                                                <div className={classes.wrapper}>
                                                    <div className={`${classes.arrowSteps} ${classes.clearfixAfter}`}>
                                                        <div className={`step ${mandateStatuses.marineVolume[0]}`}>
                                                            <span>{mandateStatuses.marineVolume[1]}</span>
                                                        </div>
                                                        <div className={`step ${mandateStatuses.marineAllocation[0]}`}>
                                                            <span>{mandateStatuses.marineAllocation[1]}</span>
                                                        </div>
                                                        <div className={`step ${mandateStatuses.marineReport[0]}`}>
                                                            <span>{mandateStatuses.marineReport[1]}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleMarineVolume}
                                            className={classes.buttonMargin}
                                            disabled={marineDataId !== null && marineVolConfirmed}
                                        >
                                            Add Volume
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleMarineVolume}
                                            className={classes.buttonMargin}
                                            disabled={marineDataId === null || (marineDataId && !marineVolConfirmed)}
                                        >
                                            Edit Volume
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={() => openModalDeleteMarine()}
                                            className={classes.buttonMargin}
                                            disabled={marineDataId === null || (marineDataId && !marineVolConfirmed)}
                                        >
                                            Delete Volumes
                                        </ButtonRounded>
                                        </Grid>
                                        <Grid item xs={4}>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleMarineReport}
                                            className={classes.buttonMargin}
                                            disabled={marineDataId === null || marineHasStep || !marineVolConfirmed}
                                        >
                                            Start Allocation
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={() => setIsRestartMarineModalOpen(true)}
                                            className={classes.buttonMargin}
                                            disabled={marineDataId === null || !marineHasStep}
                                        >
                                            Restart Allocation
                                        </ButtonRounded>
                                        <ButtonRounded
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleContinueAllocationMarine}
                                            className={classes.buttonMargin}
                                            disabled={marineDataId === null || !marineHasStep}
                                        >
                                            Continue Allocation
                                        </ButtonRounded>
                                    </Grid>

                                </Grid>
                                )}
                                {showModalDeleteMarine && (
                                    <React.Suspense fallback={<div>Loading...</div>}>
                                        <ModalDeleteVolumeInMandate
                                            open={showModalDeleteMarine}
                                            handleDelete={async () => {
                                                await deleteOffRoadUseData(marineDataId, "marine");
                                                await resetAllocationMarine();
                                                await toggleMarineMandateStatus(true);
                                                // await checkData();
                                                window.location.reload();
                                            }}
                                            onClose={closeModalDeleteMarine}
                                        />
                                    </React.Suspense>
                                )}
                                {isRestartMarineModalOpen && (
                                    <React.Suspense fallback={<div>Loading...</div>}>
                                        <ModalRestartAllocation
                                            open={isRestartMarineModalOpen}
                                            handleRestart={handleConfirmAndRestartMarine}
                                            onClose={handleCloseRestartMarineModal}
                                        />
                                    </React.Suspense>
                                )}
                            </Grid>
                            <Grid>
                        </Grid>
                            <Grid item xs={3}>
                                <Typography variant="h5" className={classes.toggleCardTitle}>
                                    <p>Mandate settings</p>
                                </Typography>
                                <div className={classes.toggleButtonMargin} >
                                    <ToggleButton
                                        labels={["Enabled", "Disabled"]}
                                        defaultLabelIndex={isMarineToggleButtonEnabled ? 0 : 1}
                                        handleChange={toggleMarineMandateState}
                                    />
                                </div>
                                {isMarineToggleButtonEnabled && (
                                    <div className={classes.toggleButtonMargin} >
                                    <ToggleButton
                                        labels={["Joint Fullfillment", "Own Fullfillment"]}
                                        defaultLabelIndex={isMarineJoint ? 0 : 1}
                                        handleChange={toggleMarineJointFulfillmentState}
                                    />
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                {isToggleOffroadMarineModalOpen && (
                    <React.Suspense fallback={<div>Loading...</div>}>
                        <ModalToggleMandate
                            open={isToggleOffroadMarineModalOpen}
                            onClose={handleCloseToggleOffroadMarineModal}
                        />
                    </React.Suspense>
                )}

            <React.Suspense fallback={<div>Loading...</div>}>
                <ModalInfo
                    text={errorMessage}
                    open={showErrorModal}
                    onClose={closeErrorModal}
                />
                <ModalConfirmDelivery
                    open={showConfirmDeliveryModal}
                    onClose={closeConfirmDeliveryModal}
                    onConfirm={() => {
                        closeConfirmDeliveryModal();
                        handleConfirmationStatus();
                    }}
                />
            </React.Suspense>
        </div>
    );
});
export default MandateOverviewContainer;
